import React from 'react';
import RegisterPricingForm from './RegisterPricingForm';
import styles from '../../login/LoginForm/LoginFormCont.module.css';

const RegisterPricingFormCont = () => (
  <div className={styles['login-container']}>
    <header className={styles.header}>
      <h3 className={styles.title}>Set Your Default Pricing</h3>
      <p className={styles.des} />
      <h3 className={styles['email-header']}>Paywall and TipJar</h3>
      <hr />
    </header>
    <section>
      <RegisterPricingForm />
    </section>
  </div>
);

export default RegisterPricingFormCont;
